// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"634":"607ad8b9","787":"21a3fd2c"}[chunkId] + ".chunk.js";
};